import {
  GET_STAFFS, GET_STAFFS_COMPLETED, GET_STAFFS_FAILED,
  GET_STAFF, GET_STAFF_COMPLETED, GET_STAFF_FAILED,
  ADD_STAFF, ADD_STAFF_COMPLETED, ADD_STAFF_FAILED,
  FIRE_STAFF, FIRE_STAFF_COMPLETED, FIRE_STAFF_FAILED,
  UPDATE_STAFF, UPDATE_STAFF_COMPLETED, UPDATE_STAFF_FAILED,
  SEARCH_STAFF, SEARCH_STAFF_COMPLETED, SEARCH_STAFF_FAILED,
} from './actions';
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  staffsLoading: false,
  staffs: [],
  staffsError: null,
  staffLoading: false,
  staff: null,
  staffError: null,
  addingStaff: false,
  firingStaff: false,
  updatingStaff: false,
  search: searchDefault,
};

const staffReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_STAFF: return handleSearch(state, 'search', action.payload);
    case SEARCH_STAFF_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_STAFF_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_STAFFS: {
      return {
        ...state,
        staffsLoading: true,
        staffs: [],
        staffsError: null,
      };
    }
    case GET_STAFFS_COMPLETED: {
      return {
        ...state,
        staffsLoading: false,
        staffs: action.payload.data,
      };
    }
    case GET_STAFFS_FAILED: {
      return {
        ...state,
        staffsLoading: false,
        staffsError: action.payload.data,
      };
    }
    case GET_STAFF: {
      return {
        ...state,
        staffLoading: true,
        staff: null,
        staffError: null,
      };
    }
    case GET_STAFF_COMPLETED: {
      return {
        ...state,
        staffLoading: false,
        staff: action.payload,
      };
    }
    case GET_STAFF_FAILED: {
      return {
        ...state,
        staffLoading: false,
        staffError: action.payload,
      };
    }
    case ADD_STAFF: {
      return {
        ...state,
        addingStaff: true,
      };
    }
    case ADD_STAFF_COMPLETED: {
      return {
        ...state,
        addingStaff: false,
      };
    }
    case ADD_STAFF_FAILED: {
      return {
        ...state,
        addingStaff: false,
      };
    }
    case FIRE_STAFF: {
      return {
        ...state,
        firingStaff: true,
      };
    }
    case FIRE_STAFF_COMPLETED: {
      return {
        ...state,
        firingStaff: false,
      };
    }
    case FIRE_STAFF_FAILED: {
      return {
        ...state,
        firingStaff: false,
      };
    }
    case UPDATE_STAFF: {
      return {
        ...state,
        updatingStaff: true,
      };
    }
    case UPDATE_STAFF_COMPLETED: {
      return {
        ...state,
        updatingStaff: false,
      };
    }
    case UPDATE_STAFF_FAILED: {
      return {
        ...state,
        updatingStaff: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default staffReducer;



// WEBPACK FOOTER //
// ./src/Staff/reducer.js